module.exports = {"141124100":"临泉镇","141124101":"白文镇","141124102":"城庄镇","141124103":"兔坂镇","141124104":"克虎镇","141124105":"三交镇","141124106":"湍水头镇","141124107":"林家坪镇","141124108":"招贤镇","141124109":"碛口镇","141124110":"刘家会镇","141124111":"丛罗峪镇","141124112":"曲峪镇","141124200":"木瓜坪乡","141124201":"安业乡","141124202":"玉坪乡","141124203":"青凉寺乡","141124204":"石白头乡","141124205":"雷家碛乡","141124206":"八堡乡","141124207":"大禹乡","141124208":"车赶乡","141124209":"安家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141124.json
// module id = 470
// module chunks = 0